import { ChangeDetectionStrategy, Component, input, output, type InputSignal, type OutputEmitterRef } from '@angular/core';
import { UiButtonComponent, UiInputComponent } from '@nexus/frontend-shared-ui';
import type { WishlistAccessSharingDrawerView } from '../../types/wishlist-access-sharing-drawer-view.interface';
import { WishlistStatusPillComponent } from '../wishlist-status-pill/wishlist-status-pill.component';

@Component({
  selector: 'wishlist-access-panel',
  imports: [UiButtonComponent, UiInputComponent, WishlistStatusPillComponent],
  templateUrl: './wishlist-access-panel.component.html',
  styleUrl: './wishlist-access-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistAccessPanelComponent {
  public readonly view: InputSignal<WishlistAccessSharingDrawerView> = input.required<WishlistAccessSharingDrawerView>();
  public readonly createLinkSelected: OutputEmitterRef<void> = output<void>();
  public readonly copyLinkSelected: OutputEmitterRef<void> = output<void>();
  public readonly rotateLinkSelected: OutputEmitterRef<void> = output<void>();
  public readonly disableLinkSelected: OutputEmitterRef<void> = output<void>();

  protected handleCreateLinkSelected(): void {
    this.createLinkSelected.emit();
  }

  protected handleCopyLinkSelected(): void {
    this.copyLinkSelected.emit();
  }

  protected handleRotateLinkSelected(): void {
    this.rotateLinkSelected.emit();
  }

  protected handleDisableLinkSelected(): void {
    this.disableLinkSelected.emit();
  }
}
